// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getScheduledExams } from "../../api";
import { ExamType } from "../../types";

export const useScheduledExamsData = (
  clinicId: string | undefined,
  payload: { startDate: string; endDate: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<ExamType>>({
    queryKey: ["scheduled-exams", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getScheduledExams(token, clinicId, payload, controller.signal);
    },
    enabled: Boolean(clinicId),
    refetchOnWindowFocus: false,
    structuralSharing: false,
    staleTime: 0, // do not cache so data is always fresh on the dashboard
  });
};
